/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import styled from "styled-components";
import { useTheme } from "@material-ui/core/styles";
import { Button, Typography, Grid } from "@material-ui/core";
import { format } from "date-fns";
import useViewport from "../../helpers/useViewport";

const StyledButton = styled(({ theme, ...props }) => <Button {...props} />)`
  color: ${(props) => props.theme.palette.link.main} !important;
  text-decoration: underline !important;
`;

const RefreshResetFilters = ({
  handleReset,
  lastUpdateDate,
  isGoTrack,
  filtersBreakpoint,
  children,
}) => {
  const theme = useTheme();
  const screenWidth = useViewport();

  return (
    <>
      {screenWidth < filtersBreakpoint && isGoTrack ? (
        <>
          <Grid item xs={6}>
            <StyledButton
              theme={theme}
              onClick={handleReset}
              data-testid="reset-button"
            >
              Reset Filters
            </StyledButton>
          </Grid>
          <Grid item xs={6} style={{ textAlign: "right", paddingRight: "8px" }}>
            <Typography
              component="p"
              display="inline"
              variant="caption"
              style={{ paddingRight: "8px", position: "relative" }}
            >
              Last Refreshed: {format(lastUpdateDate, "MM/dd/yyyy HH:mm")}
            </Typography>
            {children} {/* refresh button */}
          </Grid>
        </>
      ) : (
        <>
          <Typography
            component="p"
            display="block"
            variant="caption"
            style={{ paddingLeft: "8px" }}
          >
            Last Refreshed: {format(lastUpdateDate, "MM/dd/yyyy HH:mm")}
          </Typography>
          <StyledButton
            theme={theme}
            onClick={handleReset}
            data-testid="reset-button"
          >
            Reset Filters
          </StyledButton>
        </>
      )}
    </>
  );
};

export default RefreshResetFilters;
